import {useCallback, useEffect, useMemo, useState} from "react";
import {DesignerAPI, Team, TeamAPI} from "@brg/api";
import { useChannelsContext } from "shared/contexts/ChannelsContext";
import { ModerationType } from "shared/pages/teams/const/ModerationTypes";
import { useDesignerById } from "./useDesignerById";

export const useGetPersonalChannel = (userId: string, needRequest?: boolean) => {
    const [isFetching, setIsFetching] = useState(false);
    const [data, setData] = useState<any>(null)

    const { 
        channels, 
        loading, error
    } = useChannelsContext();

    const fetchPersonalChannel = useCallback(async (id: string) => {
        if (!id) return;
        setIsFetching(true);

        try {
            const [userRes, teamsRes] = await Promise.all([
                DesignerAPI.Get({ idDesigner: id }).then(r => r.json()),
                TeamAPI.GetList({
                    moderationTypes: [/*ModerationType.Channel,*/ ModerationType.Outer, ModerationType.ChannelGroupOrCourse],
                    statuses: [0, 2, 3, 4],
                    ownerOrMemberIds: [id]
                }).then(r => r.json())
            ]);

            const list = needRequest ? teamsRes?.data || teamsRes : channels;

            const defaultUserChannelId = userRes?.defaultEduChannelId;
            const personalChannels = list?.filter((ch: any) => 
                ch?.moderationType === ModerationType.Outer &&
                ch?.ownersIDs?.length === 1 &&
                ch.ownersIDs.includes(id)
            );
            const isOnlyChannel = personalChannels?.length === 1;

            const defaultChannel = isOnlyChannel 
                ? personalChannels?.[0]?.teamId 
                : list?.find((ch: any) => ch.teamId === defaultUserChannelId)?.teamId || ''

            setData({
                personalChannels,
                defaultChannel,
                autoChannel: list?.[0]
            });
        } catch (err) {
            console.error(err);
        } finally {
            setIsFetching(false);
        }
    }, [channels, needRequest]); 

    useEffect(() => {
        if (needRequest && userId) {
            fetchPersonalChannel(userId)
        }
    } , [needRequest, userId])

    return {data, isLoading: loading || isFetching, error};
}import {useCallback, useEffect, useMemo, useState} from "react";
import {DesignerAPI, Team, TeamAPI} from "@brg/api";
import { useChannelsContext } from "shared/contexts/ChannelsContext";
import { ModerationType } from "shared/pages/teams/const/ModerationTypes";
import { useDesignerById } from "./useDesignerById";

export const useGetPersonalChannel = (userId: string, needRequest?: boolean) => {
    const [isFetching, setIsFetching] = useState(false);
    const [data, setData] = useState<any>(null)

    const { 
        channels, 
        loading, error
    } = useChannelsContext();

    const fetchPersonalChannel = useCallback(async (id: string) => {
        if (!id) return;
        setIsFetching(true);

        try {
            const [userRes, teamsRes] = await Promise.all([
                DesignerAPI.Get({ idDesigner: id }).then(r => r.json()),
                TeamAPI.GetList({
                    moderationTypes: [/*ModerationType.Channel,*/ ModerationType.Outer, ModerationType.ChannelGroupOrCourse],
                    statuses: [0, 2, 3, 4],
                    ownerOrMemberIds: [id]
                }).then(r => r.json())
            ]);

            const list = needRequest ? teamsRes?.data || teamsRes : channels;

            const defaultUserChannelId = userRes?.defaultEduChannelId;
            const personalChannels = list?.filter((ch: any) => 
                ch?.moderationType === ModerationType.Outer &&
                ch?.ownersIDs?.length === 1 &&
                ch.ownersIDs.includes(id)
            );
            const isOnlyChannel = personalChannels?.length === 1;

            const defaultChannel = isOnlyChannel 
                ? personalChannels?.[0]?.teamId 
                : list?.find((ch: any) => ch.teamId === defaultUserChannelId)?.teamId || ''

            setData({
                personalChannels,
                defaultChannel,
                autoChannel: list?.[0]
            });
        } catch (err) {
            console.error(err);
        } finally {
            setIsFetching(false);
        }
    }, [channels, needRequest]); 

    useEffect(() => {
        if (needRequest && userId) {
            fetchPersonalChannel(userId)
        }
    } , [needRequest, userId])

    return {data, isLoading: loading || isFetching, error};
}